import { createStore } from 'vuex'

export default createStore({
	state: {
		user: null,
		si: {
			'aml': false,
			'cll': false
		}
	},
	getters: {
		siAccessed: state => {
			return state.si
		},
		userInfo: state => {
			return state.user
		}
	},
	mutations: {
		setSI(state,payload){
			state.si[payload] = true
		},
		setUser(state,payload){
			state.user = payload
		}
	},
	actions: {
		overviewSeen(context,payload){
			context.commit('setSI',payload)
		},
		setLogin(context,payload){
			context.commit('setUser',payload)
		}
	}
})
